<div class="panel" [ngClass]="textColor" [ngStyle]="{'background-color': color }">
  <span>{{ color }}</span>
</div>
